import { UserMissionCard } from './UserMissionCard'
import { withUserMissionCard } from './withUserMissionCard'

const Connected = withUserMissionCard(UserMissionCard)

export { Connected as UserMissionCard }
